import isNaN from 'lodash/isNaN';
import isNumber from 'lodash/isNumber';
import isString from 'lodash/isString';

const _isNumber = (value: unknown): value is number =>
  isNumber(value) && !isNaN(value);
export const isNumOrStr = (value: unknown): value is number | string =>
  _isNumber(value as number) || isString(value);
